import { useState } from "react";
import { createUser } from "../../utils/api/createUser.js";


export function RegisterPage4({ setPage, setErrors, userData, setUserData, setUser, changeSection }) {

  const validateEmail = (email) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  };

  const validateData = () => {
    var errorPage = 0;



    // Page 1
    if (userData.name == "" || userData.name == undefined) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        nameMissing: true,
      }));
      errorPage = 1;
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        nameMissing: false,
      }));
    }

    if (userData.surname1 == ""|| userData.surname1 == undefined) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        surname1Missing: true,
      }));
      errorPage = 1;
    } else { 
      setErrors((prevErrors) => ({
        ...prevErrors,
        surname1Missing: false,
      }));
    }

    if (userData.surname2 == ""|| userData.surname2 == undefined) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        surname2Missing: true,
      }));
      errorPage = 1;
    } else { 
      setErrors((prevErrors) => ({
        ...prevErrors,
        surname2Missing: false,
      }));
    }

    if (userData.email == ""|| userData.email == undefined) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        emailMissing: true,
      }));
      errorPage = 1;
    } else { 

      setErrors((prevErrors) => ({
        ...prevErrors,
        emailMissing: false,
      }));

      if (!validateEmail(userData.email)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          emailFormat: true,
        }));
        errorPage = 1;
      }else{
        setErrors((prevErrors) => ({
          ...prevErrors,
          emailFormat: false,
        }));
      }
    }

    // Page 2
    if (userData.username == ""|| userData.username == undefined) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        usernameMissing: true,
      }));
      if (errorPage == 0){
        errorPage = 2;
      }
    } else { 
      setErrors((prevErrors) => ({
        ...prevErrors,
        usernameMissing: false,
      }));
    }

    if (userData.password1 == ""|| userData.password1 == undefined) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        password1Missing: true,
      }));
      if (errorPage == 0){
        errorPage = 2;
      }
    } else { 
      setErrors((prevErrors) => ({
        ...prevErrors,
        password1Missing: false,
      }));
    }

    if (userData.password2 == ""|| userData.password2 == undefined) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        password2Missing: true,
      }));
      if (errorPage == 0){
        errorPage = 2;
      }
    } else { 
      setErrors((prevErrors) => ({
        ...prevErrors,
        password2Missing: false,
      }));
    }

    if (userData.password1 != userData.password2) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        passwordMatch: true,
      }));
      if (errorPage == 0){
        errorPage = 2;
      }
    }else{
      setErrors((prevErrors) => ({
        ...prevErrors,
        passwordMatch: false,
      }));
    }

    return errorPage;
  }

  const makeRegister = async () => {
    const response = await createUser(userData);
    if(response){
      if (response.data){
        setUser(userData.username);
        changeSection("home");
        alert("Usuario registrado");
      }else{
        if (response.error == "email_taken"){
          setErrors((prevErrors) => ({
            ...prevErrors,
            emailTaken: true,
          }));
          setPage(2);
        }else if(response.error == "username_taken"){
          setErrors((prevErrors) => ({
            ...prevErrors,
            usernameTaken: true,
          }));
          setPage(2);
        }
        alert("Error al registrarse");
      }

      
    }else{

      alert("Error al registrarse");
    }
  }


  const handleRegister = () => {
    const errorPage = validateData();
    if (errorPage==0) {
      makeRegister();
    } else {
      setPage(errorPage);
    }
  }

  const handleResidenceChange = (event) => {
    const newData = event.target.value;

    setUserData((prevUser) => ({
      ...prevUser,  
      residence: newData,
    }));
  };

  const handleAdvantagesChange = (event) => {
    const newData = event.target.value;

    setUserData((prevUser) => ({
      ...prevUser,  
      advantages: newData,
    }));
  };

  const handleFamilyChange = (event) => {
    const newData = event.target.value;

    setUserData((prevUser) => ({
      ...prevUser,  
      family: newData,
    }));
  };

  const handleTimChange = (event) => {
    const newData = event.target.value;

    setUserData((prevUser) => ({
      ...prevUser,  
      family: newData,
    }));
  };

  return (
    <>
      <div className="m-frmGroup">
        Residente
        <select name="residente" id="residente" onChange={(e) => handleResidenceChange(e)}>
          <option value="no">No</option>
          <option value="ceuta">Ceuta/Melilla</option>
          <option value="baleares">Islas Baleares</option>
          <option value="canarias">Islas Canarias</option>
        </select>
      </div>
                        
      <div className="m-frmGroup">
        Bonificación
        <select name="bonificacion" id="bonificacion" onChange={(e) => handleAdvantagesChange(e)}>
          <option value="no">No</option>
          <option value="ET1">Ejercito Tierra Generales Almirantes</option>
          <option value="ET2">Ejercito Tierra Oficiales Suboficiales</option>
          <option value="ET3">Ejercito Tierra Tropa Marineria</option>
          <option value="FN1">Fuerzas Navales Generales Almirantes</option>
          <option value="FN2">Fuerzas Navales Oficiales Suboficiales</option>
          <option value="FN3">Fuerzas Navales Tropa Marineria</option>
          <option value="GCS">Guardia Civil</option>
          <option value="POL">Policia Nacional</option>
          <option value="CJ">Carnet Joven</option>
          <option value="tercera">Tercera Edad</option>
        </select>
      </div>
                        
      <div className="m-frmGroup">
        Familia numerosa
        <select name="f_numerosa" id="f_numerosa" onChange={(e) => handleFamilyChange(e)}>
          <option value="no">No</option>
          <option value="FNESPECIAL">Especial</option>
          <option value="FNGENERAL">General</option>
        </select>
      </div>
                        
      <div className="m-frmGroup">
        TIM
        <input 
          type="text" 
          placeholder="TIM" 
          id="TIM"
          onChange={(e) => handleTimChange(e)}
          />
      </div>
                                          
      <div className="m-frmGroup">
        <div className="chRad">
          <input type="checkbox" name="newsletter_flag" data-gtm-form-interact-field-id="0"/>
          <span>
            Deseo recibir notificaciones de portalferry 
                <br/> 
            <small>Consulta  aquí nuestra <a href="">política de privacidad</a></small>
          </span>       
        </div>
      </div>
            
      <br/>
      <div className="row content-flex-end">
        <div className="btnBlue-l btnArrow-l float-right" value="Buscar" onClick={() => handleRegister()}>Seguir</div>
      </div>
                        
    </>
  )};